import { Component, OnInit, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, ControlValueAccessor } from '@angular/forms';
import { LocalizationService } from '../../services/localization.service';

@Component({
    selector: 'app-pg-duration',
    templateUrl: './pg-duration.component.html',
    styleUrls: ['./pg-duration.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PgDurationComponent),
            multi: true
        }, {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PgDurationComponent),
            multi: true,
        }],
    standalone: false
})
export class PgDurationComponent implements OnInit, ControlValueAccessor, Validator {
    @Input() fieldId:string;

    @Input() readonly:boolean;
    @Input() required:boolean;

    unitOptions:Array<{
        id:string,
        text: string,
        fromUnit: (value:string) => any,
        toUnit: (value:any) => string,
    }> = [{
        id: 'hh',
        text: 'pg-duration.hh',
        fromUnit: (value) => {
            if(value != null && value != '') {
                if(/\d+:\d\d/.test(value)) {
                    let _split = value.split(':')

                    let _hours = parseInt(_split[0])
                    let _minutes = parseInt(_split[1])

                    if(!isNaN(_hours) && !isNaN(_minutes)) return (_hours + _minutes / 60).toString();
                }
                else {
                    let _value = parseFloat(value)
                    if(!isNaN(_value)) return _value.toString()
                }
            }
        },
        toUnit: (value) => {
            if(value != null && value != '') {
                return this.localizationService.format.duration(parseInt(value) * 60 * 60 * 1000, false, false, true)
            }
        }
    }, {
        id: 'dd',
        text: 'pg-duration.dd',
        fromUnit: (value) => {
            if(value != null && value != '') {
                let _value = parseFloat(value)
                if(!isNaN(_value)) return (_value * 24).toString()
            }
        },
        toUnit: (value) => {
            if(value != null && value != '') {
                let _value = parseFloat(value)
                if(!isNaN(_value)) return (Math.round(_value / 24 * 1000) / 1000).toString();
            }
        }
    }]

    value:string = null;

    unit = 'hh'
    unitValue:string = null;

    constructor(private localizationService:LocalizationService) { }

    ngOnInit() {
    }

    resetUnitValue() {
        this.unitValue = this.getSelectedUnit().toUnit(this.value)
    }

    getSelectedUnit() {
        for(let _item of this.unitOptions) {
            if(_item.id == this.unit) return _item
        }
    }

    setSelectedUnit(id:string) {
        this.unit = id;
        this.resetUnitValue();
    }

    onUnitValueChange() {
        this.value = this.getSelectedUnit().fromUnit(this.unitValue)
        this.onValueChange();
    }

    onValueChange() {
        if(this._onTouched != null) this._onTouched();
        if(this._onChange != null) this._onChange(this.value);
    }

    // INTERFACCIA ControlValueAccessor

    writeValue(obj:string) {
        this.value = obj;
        
        if(this.value != null && this.value != '') {
            let _hoursNum = parseInt(obj)
            if(!isNaN(_hoursNum) && _hoursNum >= 36) {
                this.unit = 'dd'
            }
        }
        
        this.resetUnitValue();
    }

    _onChange;

    registerOnChange(fn: any) {
        this._onChange = fn;
    }

    _onTouched;

    registerOnTouched(fn: any) {
        this._onTouched = fn;
    }

    // INTERFACCIA Validator

    validate()  {
        if(this.value == null || this.value == '') {
            if(this.required) {
                return {
                    required: {
                        valid: false
                    }
                } 
            }
            else if(this.unitValue != null && this.unitValue != '') {
                return {
                    format: {
                        valid: false
                    }
                } 
            }
        }
    };
}
